import React from 'react'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import Select from 'react-select'

export const valueList = [
    { value: 'straighter_teeth', label: 'Straighter teeth' },
    { value: 'improve_esthetics', label: 'Improve esthetics' },
    { value: 'solve_anterior_crowding', label: 'Solve anterior crowding' },
    { value: 'solve_anterior_spacing', label: 'Solve anterior spacing' },
    { value: 'diastema_closure', label: 'Diastema Closure' },
    { value: 'gap_closure', label: 'Gap closure' },
    { value: 'midline_correction', label: 'Midline correction' },
    { value: 'overbite_correction', label: 'Overbite correction' },
    { value: 'openbite_correction', label: 'Openbite correction' },
    { value: 'anterior_crossbite_correction', label: 'Anterior crossbite correction' },
]


const AlignerTreatmentExpectation = ({ anamnesis }) => {
    if (!anamnesis.formData) {
        return null
    }
    const keyList = Object.keys(anamnesis.formData)

    const renderValue = (key) => {
        const value = anamnesis.formData[key]
        if (value === true) {
            return 'yes'
        }
        if (value === false) {
            return 'no'
        }
        return value
    }

    return (

        <Row top="M">
            <Column>
                <table className="customer-form-table">
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {keyList.map(key => {
                            return key === 'medicalAssesment' ? null : (
                                <tr key={key}>
                                    <td className="key">{key}</td>
                                    <td className="value">{renderValue(key)}</td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td>Medical Assessment</td>
                            <td>
                                <Select
                                    isMulti
                                    isDisabled={true}
                                    defaultValue={anamnesis.formData.medicalAssesment || []}
                                    onChange={() => {}}
                                    options={valueList}
                                    classNamePrefix="sunshine-multi-select"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Column>
        </Row>

    )
}

export default AlignerTreatmentExpectation



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/AlignerTreatmentExpectation.js